var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAviationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aviationIcon",
    clipPath: "url(#clip0_2923_500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aviationIcon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "animi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aviation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.2455 25.1451L15.0087 41.3849L9.49711 39.0947L9.00492 39.5928L16.0195 44.2703L20.6999 51.285L21.1951 50.7898L18.908 45.2783L35.1448 29.0444L47.9008 47.4711L48.5197 46.858L40.0108 24.1754L52.979 11.2131C53.4686 10.6905 53.7358 9.99797 53.7241 9.28204C53.7124 8.56606 53.4228 7.88267 52.9165 7.37633C52.4101 6.86999 51.7267 6.58038 51.0107 6.56869C50.2948 6.55701 49.6023 6.8242 49.0797 7.31376L36.1115 20.279L13.4347 11.7731L12.8158 12.389L31.2455 25.1451ZM47.1315 56.0419L34.3696 37.6122L25.4097 46.5721L27.6998 52.0836L19.8422 59.9382L12.0465 48.2462L0.351562 40.4476L8.20913 32.59L13.7177 34.8771L22.6775 25.9173L4.24793 13.1613L12.0465 5.36558L34.7262 13.8687L45.1804 3.41445C45.945 2.63142 46.8573 2.00791 47.8646 1.58007C48.8718 1.15223 49.954 0.928561 51.0484 0.922023C52.1427 0.915486 53.2275 1.12621 54.2398 1.54199C55.2521 1.95776 56.1718 2.57032 56.9457 3.34416C57.7195 4.11799 58.3321 5.03773 58.7479 6.05004C59.1636 7.06236 59.3743 8.14712 59.3678 9.24148C59.3613 10.3358 59.1376 11.418 58.7097 12.4253C58.2819 13.4325 57.6584 14.3449 56.8754 15.1095L46.4212 25.5636L54.9272 48.2462L47.1285 56.0419H47.1315Z",
    fill: "#E5E5E5"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2923_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviationIcon);
export default __webpack_public_path__ + "static/media/aviationIcon.c1c07cd4207b180b857969f0264683d3.svg";
export { ForwardRef as ReactComponent };